import { apiPath } from '../_utils/api-version'
import { IRecommended } from '../_types'
import { request } from './http-client'
import { TParams } from './types'

export const getRecommended = (
  params: TParams,
  shipper_id?: string,
  platform_id?: string,
  useDynamicLanguage = false
) => {
  return request.get<{ count: any; recommended_products: IRecommended[] }>(
    apiPath('recommended_products', useDynamicLanguage),
    {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }
  )
}

export const recommendedService = {
  getAll: (
    params: TParams,
    shipper_id?: string,
    platform_id?: string,
    useDynamicLanguage = false
  ) => getRecommended(params, shipper_id, platform_id, useDynamicLanguage),
}

export default recommendedService
